import uniqBy from 'lodash/uniqBy';
import {sortOptionsFactory, filterOptionsFactory} from 'viewOptions/factories';
import * as ResourceActions from 'resources/actions';
import * as ResourceApi from 'api/resources';
import * as WinnersActions from './actions';
import {toggleSort} from 'utils/DBUtils';

// fetch the prize associated with these winners, but only the first time this page has been mounted.
const requestPrizeEpic = action$ => action$.ofType(WinnersActions.Types.REQUEST_PRIZE_WINNERS)
  .map(action => ResourceActions.getResourceAction(ResourceApi.Types.Prize, action.prizeId));

const requestPrizeWinnersEpic = (action$, store) => action$.ofType(
  WinnersActions.Types.REQUEST_PRIZE_WINNERS,
  ResourceActions.Types.UPDATE_PAGE_NUMBER_FOR_RESOURCE
)
  .filter(action => {
    if (action.type === WinnersActions.Types.REQUEST_PRIZE_WINNERS) {
      return true;
    } else {
      return action.resourceType === ResourceApi.Types.PrizeEntry && action.params.multipleWinners === true;
    }
  })
  .map(action => {
    const {currentPrizeId} = store.getState().multipleWinners;
    const prizeId = action.prizeId || currentPrizeId;

    const sortOptions = sortOptionsFactory('lastName');
    sortOptions.sorts = toggleSort(sortOptions.sorts, 'lastName');

    const filterOptions = filterOptionsFactory({
      filters: [
        {field: 'prizeId', value: prizeId},
        {field: 'winner', value: true}
      ]
    });

    return ResourceActions.getResourcePageAction(
      ResourceApi.Types.PrizeEntry,
      20,
      action.page || 1,
      sortOptions,
      filterOptions,
      null,
      {multipleWinners: true}
    );
  });

// once we have all the winning entries for this prize, we will also need each entrant's prize history.
const requestPrizeHistoriesEpic = action$ => action$.ofType(ResourceActions.Types.RECEIVED_RESOURCE_PAGE)
  .filter(action => action.resourceType === ResourceApi.Types.PrizeEntry && action.params.multipleWinners === true)
  .mergeMap(action => {
    const winnerUserIds = uniqBy(action.resourcePage.object, 'userId');

    const sortOptions = sortOptionsFactory('dateWon');
    sortOptions.sorts = toggleSort(sortOptions.sorts, 'dateWon');

    return winnerUserIds.map(({userId}) => {
      const filterOptions = filterOptionsFactory({
        filters: [
          {field: 'winner', value: true},
          {field: 'userId', value: userId}
        ]
      });

      return ResourceActions.getAllResourcesAction(
        ResourceApi.Types.PrizeEntry,
        sortOptions,
        filterOptions,
        {userId, multipleWinners: true}
      );
    });
  });

const receivedPrizeHistoriesEpic = action$ => action$.ofType('RECEIVED_ALL_RESOURCES_PRIZEENTRY')
  .filter(action => action.resourceType === ResourceApi.Types.PrizeEntry && action.params.multipleWinners === true)
  .map(action => WinnersActions.receivedWinnerHistoryAction(action.params.userId, action.resources));

export default [
  requestPrizeEpic,
  requestPrizeWinnersEpic,
  requestPrizeHistoriesEpic,
  receivedPrizeHistoriesEpic
];



// WEBPACK FOOTER //
// ./public/pages/MultipleWinners/epics.js